import React, { useEffect } from 'react';
import { string } from 'prop-types';

import useRsvp from '@/usecase/use-rsvp';
import useCobaLink from '@/hooks/useCobaLink';
import { ENABLE_DUAL_PHOTO } from '@/constants/feature-flags';

import DualPhoto from './DualPhoto';
import SinglePhoto from './SinglePhoto';

/**
 * Render couple info
 * @param {*} props
 * @returns
 */
function CoupleInfo({ ...rest }) {
  const { onOpenInvitation } = useRsvp();
  const { onValidateCobaLink } = useCobaLink();

  useEffect(() => {
    onValidateCobaLink(onOpenInvitation);
    // expected to running for once only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ENABLE_DUAL_PHOTO ? <DualPhoto {...rest} /> : <SinglePhoto {...rest} />;
}

CoupleInfo.propTypes = {
  lang: string,
};

export default CoupleInfo;
